import { render, staticRenderFns } from "./BudgetActuals.vue?vue&type=template&id=5aa42a9c&"
import script from "./BudgetActuals.vue?vue&type=script&lang=js&"
export * from "./BudgetActuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports